import React, {FC, forwardRef} from 'react';

import {cn} from '@bem-react/classname';
import {Checkbox} from '@gravity-ui/uikit';

import QuestionLable from '../QuestionLabel';
import QuestionLayout, {QuestionLayoutType} from '../QuestionLayout';

import {booleanQuestionPositions} from './BooleanQuestion.constants';
import {BooleanQuestionProps} from './BooleanQuestion.types';

import './BooleanQuestion.scss';

const cnBooleanQuestion = cn('BooleanQuestion');

const BooleanQuestion: FC<BooleanQuestionProps> = forwardRef<
    HTMLLabelElement,
    BooleanQuestionProps
>(function BooleanQuestion({className, checked, label, required, size = 'l', ...props}, ref) {
    return (
        <QuestionLayout
            {...props}
            type={QuestionLayoutType.Column}
            positions={booleanQuestionPositions}
            className={cnBooleanQuestion('', [className])}
            required={required}
            control={
                <div className={cnBooleanQuestion('Control')}>
                    {required && <span className={cnBooleanQuestion('Required')}>*</span>}
                    <Checkbox
                        {...props}
                        ref={ref}
                        size={size}
                        checked={checked}
                        className={cnBooleanQuestion('Checkbox', {checked})}
                        content={<QuestionLable text={label} required={false} />}
                    />
                </div>
            }
        />
    );
});

export default BooleanQuestion;
